module.exports = __webpack_public_path__ + "static/media/Portrait-10026.5a778734.jpg";